import fondoQuimsa from '../assets/fondo-quimsa.png';
import sponsor1 from '../assets/sponsor1.png';
import sponsor2 from '../assets/sponsor2.png';
import sponsor3 from '../assets/sponsor3.png';
import sponsor4 from '../assets/sponsor4.png';

const Sponsors = () => {
  const logos = [sponsor1, sponsor2, sponsor3, sponsor4];

  return (
    <section className="relative py-16 px-4 bg-[#f2f2f2] overflow-hidden">
      {/* Imagen de fondo */}
      <img
        src={fondoQuimsa}
        alt="QUIMSA fondo"
        className="absolute inset-0 w-full h-full object-cover opacity-10"
      />

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col gap-12">
        {/* Sponsors */}
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#202C5A] uppercase mb-8 text-left">
            Sponsors
          </h2>
          <div className="flex flex-wrap justify-center gap-6 md:gap-10">
            {logos.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Sponsor ${i + 1}`}
                className="h-12 md:h-16 object-contain max-w-[160px] md:max-w-[180px]"
              />
            ))}
          </div>
        </div>

        {/* Donde estamos */}
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#202C5A] uppercase text-left">
            Dónde estamos
          </h2>
          {/* Aquí puedes agregar el mapa u otra info luego */}
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
